const trustpilotSummaryCache = new Map();
const trustpilotSummaryInflight = new Map();

if (!customElements.get('custom-trustpilot-summary')) {
  customElements.define(
    'custom-trustpilot-summary',
    class CustomTrustpilotSummary extends HTMLElement {
      connectedCallback() {
        this.loadTrustpilotSummary();
      }

      getCacheKey() {
        const { trustpilotBusinessUnitId: businessUnitId, trustpilotTemplateId: templateId } = this.dataset;
        const locale = this.dataset.trustpilotLocale || 'en-US';

        return businessUnitId && templateId ? `${businessUnitId}:${templateId}:${locale}` : null;
      }

      fetchTrustpilotSummary(cacheKey) {
        const { trustpilotBusinessUnitId: businessUnitId, trustpilotTemplateId: templateId, trustpilotToken: token } =
          this.dataset;
        const locale = this.dataset.trustpilotLocale || 'en-US';
        const params = new URLSearchParams({ businessUnitId, locale, theme: 'light', token });

        return fetch(`https://widget.trustpilot.com/trustbox-data/${templateId}?${params}`)
          .then((response) => (response.ok ? response.json() : null))
          .then((data) => {
            if (data) {
              trustpilotSummaryCache.set(cacheKey, data);
            }

            return data;
          })
          .catch(() => null)
          .finally(() => {
            trustpilotSummaryInflight.delete(cacheKey);
          });
      }

      async loadTrustpilotSummary() {
        const { trustpilotBusinessUnitId: businessUnitId, trustpilotTemplateId: templateId, trustpilotToken: token } =
          this.dataset;
        const cacheKey = this.getCacheKey();

        if (!businessUnitId || !templateId || !token || !cacheKey) {
          return;
        }

        if (trustpilotSummaryCache.has(cacheKey)) {
          this.updateTrustpilotSummary(trustpilotSummaryCache.get(cacheKey));
          return;
        }

        if (!trustpilotSummaryInflight.has(cacheKey)) {
          trustpilotSummaryInflight.set(cacheKey, this.fetchTrustpilotSummary(cacheKey));
        }

        const data = await trustpilotSummaryInflight.get(cacheKey);

        if (data) {
          this.updateTrustpilotSummary(data);
        }
      }

      updateTrustpilotSummary(data) {
        const scoreElement = this.querySelector('[data-trustpilot-score]');
        const reviewCountElement = this.querySelector('[data-trustpilot-review-count]');
        const ratingLinkElement = this.querySelector('[data-trustpilot-rating-link]');
        const reviewsLinkElement = this.querySelector('[data-trustpilot-reviews-link]');
        const totalReviews = data?.businessEntity?.numberOfReviews?.total;
        const scoreLabel = data?.starsString;

        if (scoreElement && scoreLabel && this.dataset.trustpilotSyncScore === 'true') {
          scoreElement.textContent = scoreLabel;
        }

        if (reviewCountElement && totalReviews != null) {
          reviewCountElement.textContent = new Intl.NumberFormat(this.dataset.trustpilotLocale || 'en-US').format(
            totalReviews
          );
        }

        if (ratingLinkElement && scoreElement) {
          ratingLinkElement.setAttribute('aria-label', `Trustpilot rating: ${scoreElement.textContent}`);
        }

        if (reviewsLinkElement && reviewCountElement) {
          const reviewsMeta = reviewCountElement.closest('.custom-results-trustpilot-cards__trustpilot-meta');
          const reviewsLabel = reviewsMeta?.textContent?.trim() || reviewCountElement.textContent;

          reviewsLinkElement.setAttribute('aria-label', `Read ${reviewsLabel} on Trustpilot`);
        }
      }
    }
  );
}
